import type { FC } from "react";

import { LockOutlineCloseIcon } from "@jti/brand-icons/lock-outline-close";
import { LockOutlineOpenIcon } from "@jti/brand-icons/lock-outline-open";
import { Badge, type BadgeVariant } from "@jti/core-components/components/Badge";

export type Tier = "default" | "silver" | "gold" | "black" | "none";

export const TIERS_LIST = ["default", "silver", "gold", "black", "none"] as const;

const TIER_TO_VARIANT: Record<Tier, BadgeVariant> = {
  default: "neutral-bold",
  black: "club-tier3",
  silver: "club-tier1",
  gold: "club-tier2",
  none: "ghost",
};

export type TierBadgePropsType = {
  tier?: string;
  isIconHidden?: boolean;
  isAvailable?: boolean;
  className?: string;
  text?: string;
};

export const checkIfTierExists = (tier: string): tier is Tier =>
  TIERS_LIST.some((tierFromList) => tierFromList === tier.toLowerCase());

export const TierBadge: FC<TierBadgePropsType> = ({ tier, isAvailable, isIconHidden, className, text }) => {
  if (!tier) return null;
  const parsedTier = tier.toLowerCase();
  if (!checkIfTierExists(parsedTier)) return null;
  const LockIcon = isAvailable ? LockOutlineOpenIcon : LockOutlineCloseIcon;
  return (
    <div className={className}>
      <Badge
        variant={TIER_TO_VARIANT[parsedTier]}
        icon={isIconHidden ? undefined : LockIcon}
        data-testid={`tierBadge${isAvailable ? "Available" : "NotAvailable"}`}
        label={text}
      />
    </div>
  );
};
